<template>
  <div name="demo-validate-required-when-exist">
    <hrms-timepicker  v-model="timstrt" 
                      v-validate="'requiredWhenExist:timend|date_format:HH:mm'"
                      data-vv-value-path="inputTime"
                      data-vv-name="timstrt"
                      name="timstrt"
                      :has-error="errors.has('timstrt')" />
    <div class="text-error" v-show="errors.has('timstrt')">{{errors.first('timstrt')}}</div>

    <hrms-timepicker  v-model="timend" 
                      v-validate="'requiredWhenExist:timstrt|date_format:HH:mm'"
                      data-vv-value-path="inputTime"
                      data-vv-name="timend"
                      name="timend"
                      :has-error="errors.has('timend')" />
    <div class="text-error" v-show="errors.has('timend')">{{errors.first('timend')}}</div>
  </div>
</template>

<script>
export default {
  name: 'demo-validate-required-when-exist',
  data () {
    return {
      timstrt: '',
      timend: ''
    }
  },
  watch: {
    timstrt () {
      this.$validator.validate('timend', this.timend).catch(e => {})
    },
    timend () {
      this.$validator.validate('timstrt', this.timstrt).catch(e => {})
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoValidateRequiredWhenExist.vue?7438ee8e